import UserTable from "../../components/User/UserTable"
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

function User() {
  const { authState } = useSelector(
    (state) => state
  );
  const { loggedIn, userInfo } = authState;
  const navigate = useNavigate();

  useEffect(() => {
    if(loggedIn != true){
      navigate("/signin")
    }
  },[loggedIn, userInfo]);

  return (
    <div className="">
      <UserTable />
    </div>
  );
}

export default User;
